import * as React from 'react'

import { overrideStyledVariantValue } from '~/utilities/override-styled-variant-value/overrideStyledVariantValue'

import { Text } from '../text/Text'
import { AvatarRootContext } from './AvatarContext'
import { AvatarPlaceholder } from './AvatarPlaceholder'

const toTextSize = {
  xs: 'xs',
  sm: 'sm',
  md: 'sm',
  lg: 'md',
  xl: 'md',
  xxl: 'lg'
}

export const AvatarInitial = () => {
  const rootContext = React.useContext(AvatarRootContext)
  const { name, size } = rootContext
  const textSize = React.useMemo(
    () => overrideStyledVariantValue(size, (s) => toTextSize[s]),
    [size]
  )

  if (!name) {
    return <AvatarPlaceholder />
  }

  return (
    <Text size={textSize} className="text-grey-800">
      {name[0].toUpperCase()}
    </Text>
  )
}
